import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { COLOR_SECONDARY_2 } from 'src/utils/colors';
import { COLOR_E } from 'src/utils/const';

const UnlockButton = ({
  handleOnSampleClick,
  fontSizeHeading,
  noBackdrop,
  noBackDropClickBlock
}: {
  handleOnSampleClick: () => void;
  fontSizeHeading?: 'small' | 'large';
  noBackdrop?: boolean;
  noBackDropClickBlock?: boolean;
}) => {
  const currentMarketName = useSelector(state => (state as any).dashboard.search.data.name);

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: '90%',
          minWidth: '300px',
          letterSpacing: '4px',
          fontWeight: 900,
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          background: noBackdrop === true? 'transparent' : '#fff',
          pointerEvents: noBackDropClickBlock === true ? 'none' : 'auto',
          borderRadius: 8,
          padding: '4px 10px',
          zIndex: +5,
        }}
      >
        <Typography
          sx={{
            fontSize: fontSizeHeading === 'small' ? '16px' : '24px',
            color: COLOR_E,
            fontWeight: 700,
          }}
        >
          PREMIUM
        </Typography>

        <Typography
          sx={{
            fontSize: fontSizeHeading === 'small' ? '18px' : '34px',
            color: '#000',
            fontWeight: 700,
            cursor: 'pointer',
          }}
          onClick={() => {
            handleOnSampleClick();
          }}
        >
          Unlock for {currentMarketName}
        </Typography>
      </Box>

      {/* Backdrop */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: '#fff7',
            backdropFilter: 'saturate(0.8)',
            mixBlendMode: 'color-dodge',
          }}
        />
    </>
  );
};

export default UnlockButton;
